// @ai-generated 2026-08-12T07:36:46+00:00 by matthias.gessinger@synqony.com using Claude Opus 5
import type { SelectOption } from '@synqo/frontend-component-library';
import { EnumRequisitionOrigin } from './Generated';

/** Whether the customer submitted this requisition themselves, rather than it being recorded for them. */
export function isSelfSubmittedRequisition(origin: EnumRequisitionOrigin | undefined): boolean {
    return origin === undefined || origin === EnumRequisitionOrigin.Portal;
}

/** Operator wording for the origin column and the ERP detail badge. */
export function getEnumRequisitionOriginLabel(value: EnumRequisitionOrigin): string {
    switch (value) {
        case EnumRequisitionOrigin.Portal:
            return 'Portal';
        case EnumRequisitionOrigin.OperatorEntry:
            return 'Selbst erfasst';
        case EnumRequisitionOrigin.ExternalErp:
            return 'Fremdsystem';
        default:
            return 'Nicht definiert';
    }
}

/**
 * Customer-facing chip, deliberately separate from {@link getEnumRequisitionOriginLabel}: the customer
 * cares that someone else entered the order for them, not which internal channel it came through.
 * Self-submitted orders get no chip — the whole portal is theirs, so it would be noise on every row.
 */
export function getPortalRequisitionOriginLabel(value: EnumRequisitionOrigin): string | undefined {
    switch (value) {
        case EnumRequisitionOrigin.OperatorEntry:
            return 'Vom Entsorger erfasst';
        case EnumRequisitionOrigin.ExternalErp:
            return 'Für Sie erfasst';
        default:
            return undefined;
    }
}

export const requisitionOriginOptions: SelectOption<EnumRequisitionOrigin>[] = [
    {
        name: 'portal',
        label: getEnumRequisitionOriginLabel(EnumRequisitionOrigin.Portal),
        value: EnumRequisitionOrigin.Portal,
    },
    {
        name: 'operator_entry',
        label: getEnumRequisitionOriginLabel(EnumRequisitionOrigin.OperatorEntry),
        value: EnumRequisitionOrigin.OperatorEntry,
    },
    {
        name: 'external_erp',
        label: getEnumRequisitionOriginLabel(EnumRequisitionOrigin.ExternalErp),
        value: EnumRequisitionOrigin.ExternalErp,
    },
];
